// extracted by mini-css-extract-plugin
export default {"warningIcon":"WarningOutlinedWithBg_warningIcon__cIFeV"};